import React from "react";
import { Button, Empty } from "@arco-design/web-react";
import { useNavigate } from "react-router-dom";
import Content from "../Layout/Content";
import BackToReport from "./BackToReport";

// RecordNotFound replaces a detail page when its record won't load, usually
// because it was deleted, so the page doesn't sit loading or show empty values.
export default function RecordNotFound({ what, backTo, backLabel }) {
  const navigate = useNavigate();
  return (
    <Content>
      <BackToReport />
      <Empty style={{ marginTop: 48 }} description={`We couldn't load this ${what}. It may have been deleted.`} />
      <div style={{ textAlign: "center", marginTop: 12 }}>
        <Button type="primary" onClick={() => navigate(backTo)}>{backLabel}</Button>
      </div>
    </Content>
  );
}
